import {
  fromJS
} from 'immutable';
import {
  handleActions
} from 'redux-actions';
import * as Types from '../actions/constants';

const INITIAL_STATE = fromJS({
  loading: false,
  filters: {
    text: ''
  },
  data: [],
  selected: null,
  limit: 5,
  skip: 0,
  total: 0,
  error: null
});

const personasRecordsReducer = handleActions({
  [Types.FIND_PERSONAS_ATTEMPT]: (state, action) => state.merge({
    loading: true,
    error: null
  }),
  [Types.FIND_PERSONAS_SUCCESS]: (state, action) => state.merge({
    loading: false,
    data: action.payload.records,
    total: action.payload.total
  }),
  [Types.FIND_PERSONAS_FAILURE]: (state, action) => state.merge({
    loading: false,
    error: action.payload
  })
}, INITIAL_STATE);


export default personasRecordsReducer;



// WEBPACK FOOTER //
// ./client/store/reducers/personasRecordsReducer.js